export enum TypeOfResult{
  FormSubmission = "FormSubmission",
  FormConsolidation = "FormConsolidation",
  MBRRequest = "MBRRequest",
  MarketingMaterial = "MarketingMaterial",
  LenderApproval = "LenderApproval",
  ProviderOrganizationDocument = "ProviderOrganizationDocument",
  BulkDownloadJob = "BulkDownloadJob"
}
